// Alternating rather than a fixed alert string: a tab that renames itself once is easy
// to miss in a row of tabs; one that changes every second catches an eye that isn't
// looking for it. An even tick is the base, so a prompt gone inside the first second
// never renames the tab at all.

export const TITLE_ALERT_PERIOD_MS = 1_000;

export function alertTitle(base: string, alert: string, tick: number): string {
  return tick % 2 === 1 ? alert : base;
}
